module.exports = __webpack_public_path__ + "static/media/background-service.842d8ebf.svg";